import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=6273ceed&scoped=true&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"
import style0 from "./Auth.vue?vue&type=style&index=0&id=6273ceed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273ceed",
  null
  
)

export default component.exports